export const LANDING = "/";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const PASSWORD_RESET = "/reset-password";
export const SET_NEW_PASSWORD = "/set-new-password";
export const ACCOUNT = "/account";
export const TRANSACTIONS = "/transactions";
export const MANAGE_WORKOUTS = "/manage-workouts";
export const ADMIN = "/admin";
export const HOME = "/home";
export const ONBOARDING = "/onboarding";
export const REPORTS = "/reports/balance-sheet";
// Where the Reports nav entry and bare /reports land (GH#463). It used to be
// REPORTS above, gated on whether the user had favorited a saved report, so
// every visit to Reports ran a full balance-sheet query before the user had
// chosen anything. The library is a cheap list; a report loads only when one is
// chosen. NOT changed: the post-login landing (signIn.js, SetNewPassword.jsx)
// still goes to REPORTS — a separate product decision.
export const REPORTS_LIBRARY = "/reports/library";
